// Локальное хранилище JWT-токенов в localStorage.
// V1-core KISS: localStorage вместо httpOnly cookie (dev-friendly).
// Ключи: `sled.auth.accessToken`, `sled.auth.refreshToken`.

const ACCESS_KEY = 'sled.auth.accessToken';
const REFRESH_KEY = 'sled.auth.refreshToken';

/** Wrapper для localStorage с типизированным API для JWT. */
export const jwtStorage = {
  /** Получить access token (или null). */
  getAccessToken(): string | null {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(ACCESS_KEY);
  },

  /** Получить refresh token (или null). */
  getRefreshToken(): string | null {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(REFRESH_KEY);
  },

  /** Сохранить оба токена. */
  saveTokens(access: string, refresh: string): void {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(ACCESS_KEY, access);
    window.localStorage.setItem(REFRESH_KEY, refresh);
  },

  /** Очистить оба токена (logout / refresh-failure). */
  clearTokens(): void {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(ACCESS_KEY);
    window.localStorage.removeItem(REFRESH_KEY);
  },

  /** True, если оба токена непустые. */
  hasTokens(): boolean {
    const access = this.getAccessToken();
    const refresh = this.getRefreshToken();
    return Boolean(access && refresh);
  },
};
